
<template>
  <!--政务账号-->
  <div>
    <x-tabula
      :apiOrigin="apiOrigin"
      ref="table"
      :dataSource="dataSource"
      rowKey="userId"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :rowSelection="true"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam">
    <template slot="bread">
      <a-breadcrumb style="margin-bottom: 20px;">
        当前位置:
        <a-breadcrumb-item>首页</a-breadcrumb-item>
        <a-breadcrumb-item v-for="(item, index) in breadList" :key="index">
          <a href="javascript:;" @click="handleBread(index)">{{item}}</a>
        </a-breadcrumb-item>
      </a-breadcrumb>
    </template>

      <template slot="opt_status" slot-scope="{row}">
        <span>{{row.status === 1 ? '正常' : '禁用'}}</span>
      </template>
    </x-tabula>

    <a-modal
      :title="title"
      :visible="visible"
      :confirm-loading="confirmLoading.loading"
      @ok="handleOk"
      @cancel="handleCancel">
      <!-- 设为主账号-->
      <a-radio-group v-model="value" @change="onChange" v-if="title === '设为主账号'">
        <a-radio :value="1">
          <span>替换原主账号:</span>
          <div style="margin-left: 22px">与原主账号的分管区域和角色互换</div>
        </a-radio>
        <a-radio :value="2">
          <span>设为独立主账号:</span>
          <div style="margin-left: 22px">继承原主账号的分管区域和角色并成为一个独立的主账号</div>
        </a-radio>
      </a-radio-group>

      <!-- 账号转移-->
      <div v-else-if="title === '账号转移'" class="select-wrap">
        <div>
          选择主账号:
          <a-select
            placeholder="账号名（手机号）"
            :allowClear="true"
            show-search option-filter-prop="children"
            :filter-option="filterOption"
            size='large'
            style="width: 200px;margin-left:8px;"
            @change="handleChangeSin">
            <a-select-option :value="item.value" v-for="item in accountList" :key="item.value">
              <a-tooltip placement="top" :title="item.label" arrow-point-at-center>{{item.label}}</a-tooltip>
            </a-select-option>
          </a-select>
        </div>
        <div class="select-box">
          选择角色:
          <a-select
            v-model="roleValue"
            mode="multiple"
            placeholder="请选择角色"
            showSearch
            :filter-option="filterOption"
            option-filter-prop="children"
            size='large'
            style="width: 200px;margin-left:8px;"
            @change="handleChangeDou">
            <a-select-option :value="item.value" v-for="item in roleList" :key="item.value">{{item.label}}
            </a-select-option>
          </a-select>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { fetchSelect } from '../../../utils/mixins';
export default {
  mixins: [fetchSelect],
  name: 'govAccount',
  data () {
    return {
      apiOrigin: 'JAVA',
      parentUserId: undefined,
      visible: false,
      title: '设为主账号',
      confirmLoading: { loading: false },
      value: 1,
      currentRow: {},
      roleValue: [],
      breadList: ['政务账号'],
      searchParams: {
        keywords: undefined,
        roleId: undefined,
        status: undefined,
        areaId: undefined
      },
      searchList: [
        { props: ['keywords'], placeholder: '账号名、手机号、真实姓名', options: [], inputType: 'input' },
        { props: ['roleId'], placeholder: '角色', options: [], inputType: 'select' },
        { props: ['status'], placeholder: '用户状态', options: [{label: '正常', value: 1}, {label: '禁用', value: 0}], inputType: 'select' },
        {
          props: ['areaId'],
          placeholder: '管理区域',
          options: [],
          inputType: 'cascader',
          changeOnSelect: true,
          expandTrigger: 'click',
          loadData: e => {
            this.regionSelect(3, 'searchList', '1,2,3,4', e);
          }
        }
      ],
      tableOptResource: [],
      tableOptList: [
        { text: '新增', icon: 'plus', permi: ['community:govAccount:add'] },
        { text: '删除', icon: 'close', disabled: true, permi: ['community:govAccount:delete'] }
      ],
      rowOptList: [
        {text: '', handle: (row) => this.changeStatus(row), customRender: true, permi: ['community:govAccount:status']},
        {text: '修改', handle: (row) => this.$refs.table.toEdit(row, ['canDelete']), permi: ['community:govAccount:add']},
        {text: '删除', handle: (row) => this.$refs.table.showDeleteConfirm(row), permi: ['community:govAccount:delete']},
        [
          {text: '查看下级', handle: row => this.toSubordinate(row), permi: ['community:govAccount:child']},
          {text: '', rowOptText: row => row.viewAuthDesc, handle: row => this.triggerViewAuth(row), customRender: true, permi: ['community:govAccount:view']}
        ]
      ],
      childRowOptList: [
        {text: '', handle: (row) => this.changeStatus(row), customRender: true, permi: ['community:govAccount:status']},
        {text: '设为主账号', handle: (row) => this.setOwnAccount(row), permi: ['community:govAccount:primary']},
        {text: '账号转移', handle: (row) => this.accountTransfer(row), permi: ['community:govAccount:transfer']}
      ],
      columns: [
        { title: '账号名', dataIndex: 'userName', align: 'left', width: '' },
        { title: '手机', dataIndex: 'mobile', align: 'left', width: '' },
        { title: '角色', dataIndex: 'roleName', align: 'left', width: '' },
        { title: '真实姓名', dataIndex: 'trueName', align: 'left', width: '' },
        { title: '创建人', dataIndex: 'createUser', align: 'left', width: '' },
        { title: '管理区域', dataIndex: 'manageArea', align: 'left', width: '' },
        { title: '创建时间', dataIndex: 'createDateStr', align: 'left', width: '' },
        { title: '状态', dataIndex: 'status', align: 'left', width: '', scopedSlots: {customRender: 'status'} },
        { title: '操作', dataIndex: 'action', align: 'left', width: 230, scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      listApi: {
        url: '/govern/user/list',
        resHandle: '', // this.listResHandle
        searchHandle: this.searchHandle
      },
      addHandleParam: {
        route: 'addGovAccount',
        addTitle: '新增政务账号',
        editTitle: '修改政务账号'
      },
      deleteParam: {
        url: '/govern/user/',
        title: '政务账号',
        key: 'userName'
      },
      accountList: [],
      roleList: [],
      formKey: {
        parentId: '',
        roleId: ''
      }
    };
  },
  created () {
    this.getSelect();
  },
  methods: {
    /* 获取下拉 */
    getSelect () {
      this.regionSelect(3, 'searchList', '1,2,3,4');
      this.getRoleSelect();
    },
    getRoleSelect () {
      const baseUrl = '/role/govern/treeSelect';
      const url = this.breadList.length === 2 ? `${baseUrl}/${this.parentUserId}` : `${baseUrl}`;
      this.$get({ url: url }).then(({data}) => {
        this.searchList[1].options = data;
      });
    },
    /** 切换可视化版本权限 */
    triggerViewAuth (row) {
      this.$put({
        url: `/govern/user/changeViewAuth/${row.userId}`,
        params: { viewAuth: row.newViewAuth ? 0 : 1 }
      }).then(({data}) => {
        this.$message.success('切换成功');
        this.$refs.table.getTableList();
      });
    },
    /* 切换状态 */
    changeStatus (row) {
      let status = row.status === 1 ? 0 : 1;
      this.$put({
        url: `/govern/user/changeStatus/${row.userId}`,
        params: { status: status }
      }).then(({data}) => {
        this.$message.success('状态切换成功！');
        this.$refs.table.getTableList();
      });
    },
    // 查看下级账号
    toSubordinate (row) {
      this.breadList.push('查看下级账号');
      this.tableOptResource = this.tableOptList;
      this.tableOptList = [];
      for (let k in this.searchParams) {
        this.searchParams[k] = undefined;
        this.$refs.table.$refs.search.form.resetFields();
      }
      this.parentUserId = row.userId;
      this.getRoleSelect();
      this.listApi.url = `/govern/user/children/${row.userId}`;

      let temp = this.rowOptList;
      this.rowOptList = this.childRowOptList;
      this.childRowOptList = temp; // 父变子 子变父

      this.$refs.table.getTableList();
    },
    searchHandle (params) {
      if (this.breadList.length > 1) {
        this.listApi.url = `/govern/user/children/${this.parentUserId}`;
      } else {
        this.listApi.url = '/govern/user/list';
      }
      return params;
    },
    // 切换面包屑
    handleBread (e) {
      if (e === 0) {
        if (this.breadList.length === 1) {
          return false;
        } else {
          let temp = this.rowOptList;
          this.rowOptList = this.childRowOptList;
          this.childRowOptList = temp; // 父变子 子变父

          this.breadList = this.breadList.length > 1 ? this.breadList.splice(0, 1) : null;
          for (let k in this.searchParams) {
            this.searchParams[k] = undefined;
            this.$refs.table.$refs.search.form.resetFields();
          }
          this.getRoleSelect();
          this.tableOptList = this.tableOptResource;
          this.listApi.url = '/govern/user/list';
          this.$refs.table.getTableList();
        }
      }
    },
    listResHandle (data) {
      return data;
    },
    // 设为主账号
    setOwnAccount (row) {
      this.title = '设为主账号';
      this.currentRow = row;
      this.visible = true;
    },
    // 账号转移
    accountTransfer (row) {
      this.currentRow = row;
      this.title = '账号转移';
      this.visible = true;
      this.accountList = [];
      this.$get({
        url: '/govern/user/treeSelect',
        params: { userId: row.userId }
      }).then(({data}) => {
        this.accountList = data;
      });
    },
    // 确认事件
    handleOk (e) {
      if (this.title === '设为主账号') {
        if (this.value === 1) {
          this.replaceAccount();
        } else {
          this.setSingleAccount();
        }
      } else {
        this.transferAccount();
      }
    },
    // 设为独立主账号
    setSingleAccount () {
      this.$put({
        url: `/govern/user/copy/${this.currentRow.userId}`,
        btnLoading: this.confirmLoading
      }).then(res => {
        this.visible = false;
        this.$message.success(res.msg).then(() => {
        });
        this.handleBread(0);
      });
    },
    // 替换原主账号
    replaceAccount () {
      this.$put({
        url: `/govern/user/replace/${this.currentRow.userId}`,
        btnLoading: this.confirmLoading
      }).then(res => {
        this.visible = false;
        this.$message.success(res.msg).then(() => {
        });
        this.handleBread(0);
      });
    },
    /** 账号转移 */
    transferAccount () {
      if (!this.formKey.parentId) return this.$message.error('请选择主账号');
      if (!this.formKey.roleId) return this.$message.error('请选择角色');
      if (typeof this.formKey.roleId !== 'string') {
        this.formKey.roleId = this.formKey.roleId.join();
      }

      this.$put({
        url: `/govern/user/transfer/${this.currentRow.userId}`,
        params: this.formKey,
        btnLoading: this.confirmLoading
      }).then(res => {
        this.visible = false;
        this.title = '';
        for (let k in this.formKey) {
          this.formKey[k] = undefined;
        }
        this.$message.success('转移成功');
        this.handleBread(0);
      });
    },
    handleChangeSin (value) {
      this.formKey.parentId = value;
      this.roleValue = [];
      this.formKey.roleId = '';
      this.$get({
        url: `/role/govern/treeSelect/${value}`,
        params: {}
      }).then(res => {
        this.roleList = res.data;
      });
    },
    handleChangeDou (value) {
      this.formKey.roleId = value;
    },
    // 选择主账号类型
    onChange (e) {
      this.value = e.target.value;
    },
    handleCancel () {
      this.visible = false;
      this.title = '';
      this.roleValue = [];
      for (let k in this.formKey) {
        this.formKey[k] = '';
      }
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].elm.textContent.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    resHandle (res) {
      console.log('处理list返回数据: ');
      return res;
    }
  }
};
</script>

<style lang="less" scoped>
.select-wrap{
  display: flex;
  flex-direction: column;
  .select-box{
    margin: 20px 0 0 13px;
  }
}
</style>
